import styled from 'styled-components';

const StyledEyebrow = styled.div`
${({ theme }) => (`
  color: ${theme.colors.text};
  ${theme.fonts.sohneMono.regular}
  font-size: 1.2rem;
  letter-spacing: 0.2rem;
  line-height: 1.5;
  text-transform: uppercase;

  ${theme.screenSize.s992.mediaQuery} {
    font-size: 1.4rem;
  }
`)};
`;

export const StyledEyebrowLight = styled(StyledEyebrow)`
  color: ${({ theme }) => theme.colors.white};
`;

export default StyledEyebrow;